export type Lang = 'ru' | 'en';

const ru = {
  appName: 'GONG',
  tagline: 'Ланчпад токенов сообщества в Telegram',
  openInTelegram: 'Откройте это приложение из Telegram, чтобы подписать сессию. Подключение кошелька и сделки работают и без неё.',
  sessionOk: 'Сессия Telegram подтверждена.',
  sessionUnverified: 'Сессия без проверки initData: задайте BOT_TOKEN на сервере. Имя на экране — только для отрисовки.',
  sessionFail: 'Не удалось проверить initData. Торговля через кошелёк всё равно доступна.',
  connectWallet: 'Подключить кошелёк',
  walletNeeded: 'Подключите кошелёк, чтобы подписать запуск или сделку. Ключи остаются в кошельке, мы их не храним.',
  walletProofNeeded: 'Не удалось подтвердить TON Proof. Отключите кошелёк, подключите его заново и подтвердите запрос владения адресом.',
  launchToken: 'Запустить токен',
  openToken: 'Открыть токен',
  demoToken: 'Демо-кривая',
  pasteAddress: 'Адрес кривой',
  pasteAddressHint: 'Вставьте адрес контракта BondingCurve в testnet, чтобы прочитать состояние и посчитать котировку.',
  recent: 'Недавние',
  name: 'Название',
  ticker: 'Тикер',
  metadata: 'Изображение токена',
  metadataHint: 'На токене будет эта картинка. При желании замените её файлом PNG, JPEG или WebP до 5 МБ.',
  metadataRequired: 'У канала нет аватара. Загрузите картинку токена.',
  replaceImage: 'Заменить картинку токена',
  useChannelImage: 'Вернуть аватар канала',
  chooseChannel: 'Выбрать канал',
  chooseChannelHint: 'Сначала выберите канал — затем здесь появится его аватар для проверки и замены.',
  seed: 'Сид ликвидности',
  seedHint:
    'Эти TON сразу поднимают цену и входят в будущий залоченный пул. Жетоны с этой суммы на ваш кошелёк не придут. Если монета не соберёт порог градуации, забрать сид обратно нельзя.',
  devBuy: 'Покупка создателя',
  devBuyHint:
    'Это покупка на ваш кошелёк по цене уже после сида. Контракт не даст купить больше 2% выпуска. Комиссия 1% берётся как с обычной покупки.',
  launchFee: 'Плата за запуск',
  review: 'Проверить и подписать',
  buy: 'Купить',
  sell: 'Продать',
  amountTon: 'Сумма, TON',
  amountJettons: 'Сумма жетонов',
  youReceive: 'Вы получите не меньше',
  quoteTtl: 'Котировка действует {seconds} с. В транзакцию кладётся минимальный выход и срок, а не цена с экрана.',
  quoteExpired: 'Котировка истекла. Нажмите ещё раз, чтобы пересчитать минимальный выход и срок.',
  antiSnipe:
    'Сейчас действует антиснайп-комиссия {bps} bps. Она убывает от 99% до 0% за 5 секунд после открытия торговли и уходит в сид пула, а не в выплаты.',
  phaseInitializing:
    'Кривая ещё не принимает чужие сделки: сначала применяется сид ликвидности, затем покупка создателя. Это защита от снайперов, а не задержка сети.',
  phaseActive: 'Кривая открыта для покупки и продажи.',
  phaseGraduating:
    'Порог собран. Кривая переводит ликвидность в пул на DEX. Покупка и продажа на кривой уже закрыты.',
  phaseGraduated: 'Токен переехал в пул на DEX. Сделок на кривой больше нет.',
  publicCurveClosed:
    'Сид закрывает порог градуации. Публичной кривой не будет: стартовую капитализацию задают ваши TON, а запуск сразу перейдёт к градуации. Жетоны с сида на кошелёк не придут.',
  risk: 'Токен сообщества — высокорисковый инструмент. Цена может упасть до нуля, и вернуть вложенные TON будет нельзя. Мы не обещаем доходность.',
  seedLine: 'Сид ликвидности',
  devBuyLine: 'Покупка создателя',
  seedLineHint: 'В залоченный пул, 0 жетонов на кошелёк с этой суммы',
  devBuyLineHint: 'Жетоны на кошелёк создателя, лимит 2% выпуска',
  progress: 'До порога градуации',
  spot: 'Цена',
  sold: 'Продано с кривой',
  noFactory:
    'Адрес фабрики не задан. Можно проверить котировки на демо-кривой; отправка create_launch появится после деплоя в testnet.',
  factoryPaused: 'Фабрика не принимает новые запуски.',
  send: 'Подписать в кошельке',
  sending: 'Ждём подпись…',
  sent: 'Транзакция отправлена. Результат появится после подтверждения в сети.',
  confirmingLaunch: 'Транзакция отправлена. Ждём подтверждение запуска и публикацию карточки…',
  launchConfirmed: 'Токен запущен. Открываем его карточку.',
  launchConfirmationDelayed:
    'Транзакция отправлена, но индексатор ещё не подтвердил запуск. Можно закрыть экран: токен появится в «Недавних» после синхронизации.',
  back: 'Назад',
  home: 'Токены',
  demoBadge: 'Демо',
  demoHint:
    'Демо считает котировку тем же пакетом @gong/curve-math, что и контракт, но не отправляет сообщения в сеть. Для живой сделки нужен testnet.',
  minOut: 'min_out',
  validUntil: 'Срок',
  fees: 'Комиссия 1%',
  feeSplits: 'Доли комиссий (снимок запуска)',
  refund: 'Возврат при перелёте',
  connectFirst: 'Сначала подключите кошелёк.',
  invalidAddress: 'Это не адрес TON. Проверьте строку и попробуйте снова.',
  invalidAmount: 'Введите сумму больше нуля.',
  tickerHint: 'Короткий тикер, как его увидит кошелёк. Позже его нельзя переписать в контракте.',
  nameHint: 'Имя монеты в карточке. Это не обещание цены и не бренд канала.',
  totalToSign: 'К подписи',
  lookingUp: 'Читаем кривую…',
  loadFailed: 'Не удалось прочитать контракт. Проверьте сеть и адрес.',
  notActiveTrade: 'В этом состоянии кривая не принимает buy и sell.',
  needWalletForSell: 'Для продажи нужен адрес вашего жетон-кошелька. Подключите кошелёк и откройте живую кривую, не демо.',
};

const en: typeof ru = {
  appName: 'GONG',
  tagline: 'Community-token launchpad inside Telegram',
  openInTelegram: 'Open this Mini App from Telegram to sign a session. Wallet connection and trades still work without it.',
  sessionOk: 'Telegram session verified.',
  sessionUnverified: 'Session without initData verification: set BOT_TOKEN on the server. The name on screen is display-only.',
  sessionFail: 'Could not verify initData. Wallet trading is still available.',
  connectWallet: 'Connect wallet',
  walletNeeded: 'Connect a wallet to sign a launch or a trade. Keys stay in the wallet; we never hold them.',
  walletProofNeeded: 'TON Proof could not be verified. Disconnect the wallet, reconnect it, and approve the address ownership request.',
  launchToken: 'Launch a token',
  openToken: 'Open a token',
  demoToken: 'Demo curve',
  pasteAddress: 'Curve address',
  pasteAddressHint: 'Paste a BondingCurve contract address on testnet to read state and compute a quote.',
  recent: 'Recent',
  name: 'Name',
  ticker: 'Ticker',
  metadata: 'Token image',
  metadataHint: 'This image will be used for the token. You can replace it with a PNG, JPEG, or WebP file up to 5 MB.',
  metadataRequired: 'The channel has no avatar. Upload a token image.',
  replaceImage: 'Replace token image',
  useChannelImage: 'Use channel avatar again',
  chooseChannel: 'Choose channel',
  chooseChannelHint: 'Choose a channel first; its avatar will appear here for review and replacement.',
  seed: 'Liquidity seed',
  seedHint:
    'These TON raise the price immediately and go into the future locked pool. Tokens from this amount do not arrive in your wallet. If the token never graduates, the seed cannot be withdrawn.',
  devBuy: 'Creator purchase',
  devBuyHint:
    'This is a buy into your wallet at the price after the seed. The contract will not sell more than 2% of supply. The 1% trade fee applies as on a normal buy.',
  launchFee: 'Launch fee',
  review: 'Review and sign',
  buy: 'Buy',
  sell: 'Sell',
  amountTon: 'Amount, TON',
  amountJettons: 'Token amount',
  youReceive: 'You receive at least',
  quoteTtl: 'This quote lasts {seconds}s. The transaction carries min_out and a deadline, not the price on the screen.',
  quoteExpired: 'The quote expired. Tap again to recompute min_out and the deadline.',
  antiSnipe:
    'An anti-snipe fee of {bps} bps is in effect. It falls from 99% to 0% over 5 seconds after trading opens and goes into the pool seed, not to anyone as a payout.',
  phaseInitializing:
    'The curve is not taking public trades yet: it applies the liquidity seed first, then the creator purchase. That is snipe protection, not a network delay.',
  phaseActive: 'The curve is open for buy and sell.',
  phaseGraduating:
    'The threshold is met. The curve is moving liquidity into the DEX pool. Buy and sell on the curve are already closed.',
  phaseGraduated: 'This token has moved to the DEX pool. There are no more curve trades.',
  publicCurveClosed:
    'The seed closes the graduation threshold. There will be no public curve: your TON set the starting capitalization, and the launch goes straight to graduation. Seed tokens do not arrive in your wallet.',
  risk: 'A community token is a high-risk instrument. The price can go to zero, and TON you put in may not come back. We do not promise returns.',
  seedLine: 'Liquidity seed',
  devBuyLine: 'Creator purchase',
  seedLineHint: 'Into the locked pool; 0 tokens to the wallet from this amount',
  devBuyLineHint: 'Tokens to the creator wallet, capped at 2% of supply',
  progress: 'To graduation threshold',
  spot: 'Price',
  sold: 'Sold from the curve',
  noFactory:
    'Factory address is not set. You can still check quotes on the demo curve; sending create_launch waits for a testnet deploy.',
  factoryPaused: 'The factory is not accepting new launches.',
  send: 'Sign in wallet',
  sending: 'Waiting for signature…',
  sent: 'Transaction sent. The result appears after the network confirms it.',
  confirmingLaunch: 'Transaction sent. Waiting for launch confirmation and the channel card…',
  launchConfirmed: 'Token launched. Opening its page.',
  launchConfirmationDelayed:
    'The transaction was sent, but the indexer has not confirmed the launch yet. You may close this screen; the token will appear in Recent after synchronization.',
  back: 'Back',
  home: 'Tokens',
  demoBadge: 'Demo',
  demoHint:
    'The demo quotes with the same @gong/curve-math package the contract uses, but it does not send messages to the network. A live trade needs testnet.',
  minOut: 'min_out',
  validUntil: 'Valid until',
  fees: '1% fee',
  feeSplits: 'Fee shares (fixed at launch)',
  refund: 'Refund on overflow',
  connectFirst: 'Connect a wallet first.',
  invalidAddress: 'That is not a TON address. Check the string and try again.',
  invalidAmount: 'Enter an amount greater than zero.',
  tickerHint: 'Short ticker as wallets will show it. The contract cannot rewrite it later.',
  nameHint: 'Token name on the card. It is not a price promise and not the channel brand.',
  totalToSign: 'To sign',
  lookingUp: 'Reading the curve…',
  loadFailed: 'Could not read the contract. Check the network and the address.',
  notActiveTrade: 'The curve does not accept buy or sell in this state.',
  needWalletForSell: 'Selling needs your jetton wallet address. Connect a wallet and open a live curve, not the demo.',
};

const dict = { ru, en };

export type Copy = typeof ru;

export function detectLang(languageCode?: string): Lang {
  return languageCode?.toLowerCase().startsWith('en') ? 'en' : 'ru';
}

export function t(lang: Lang, key: keyof Copy, vars?: Record<string, string | number>): string {
  let value: string = dict[lang][key];
  if (!vars) {
    return value;
  }
  for (const [name, replacement] of Object.entries(vars)) {
    value = value.replaceAll(`{${name}}`, String(replacement));
  }
  return value;
}

export { dict };
